export class ColumnWidth {
    width: number;
    flex: number;
    minWidth: number;
    maxWidth: number;

    constructor (width: number, flex?: number, minWidth?: number, maxWidth?: number) {
        this.width = width;
        this.flex = flex;
        this.minWidth = minWidth;
        this.maxWidth = maxWidth;
    }
}